// import articleUrl, { buildArticleCommentsUrl as articleCommentsUrl } from '@root/modules/article/utils/buildArticleUrl';
import articleUrl from '@root/modules/article/utils/buildArticleUrl';
import matchChannel from '@root/common/utils/matchChannel';
import { Data as ArticleData } from '@root/modules/article/types/article';
import { Context } from '@nuxt/types';

interface ArticlePathContext {
  domain: string;
  fakeDomainEnabled: boolean;
  query: Context['route']['query'];
  route: Context['route'];
}

// const getArticlePath = (article: ArticleData, { domain, fakeDomainEnabled, query, route }: ArticlePathContext) => {
const getArticlePath = (article: ArticleData, { domain, fakeDomainEnabled }: ArticlePathContext) => {
  if (!article) {
    return null;
  }

  const activeDomain = article.primaryCategory?.channel?.url;
  if (!activeDomain) {
    return null;
  }

  const sameChannel = matchChannel(domain, activeDomain);
  if (sameChannel) {
    return null;
  }

  const url = articleUrl({ article, domain, fakeDomainEnabled });
  if (url) {
    return null;
  }

  return null;
};

export default getArticlePath;
